const {
  REACT_APP_DUMMY_DATA_SERVER_URL = '',
} = process.env

module.exports = {
  REACT_APP_DUMMY_DATA_SERVER_URL,
}
